import { ChangeEvent, FC } from 'react'

import { Checkbox } from '@mui/material'
import { Controller } from 'react-hook-form'

import {
  BpCheckedIcon,
  BpIcon,
  FormControlLabelStyled,
  IFormControlLabelStyled
} from './styles'

interface ICheckBox extends IFormControlLabelStyled {
  onClick?: (_event?: any) => void
  onChange?: (_event: ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  disabled?: boolean
  label?: string
  name?: string
  defaultValue?: boolean
  control?: any
  formValue?: string
}

const nolabel = 'noLabel'

export const CheckBox: FC<ICheckBox> = ({
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  label = '',
  checked,
  onClick,
  onChange,
  disabled,
  name,
  control,
  defaultValue,
  formValue
}) =>
  control ? (
    <Controller
      control={control}
      name={formValue}
      render={({ field }) => (
        <FormControlLabelStyled
          marginBottom={marginBottom}
          marginLeft={marginLeft}
          marginRight={marginRight}
          marginTop={marginTop}
          label={label}
          id={`${label ?? nolabel}-labelCheckbox`}
          checked={field.value}
          value={defaultValue}
          name={name}
          control={
            <Checkbox
              sx={{
                '&:hover': { bgcolor: 'transparent' }
              }}
              disableRipple
              color="default"
              checkedIcon={<BpCheckedIcon />}
              icon={<BpIcon />}
              onClick={onClick}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
              }}
              disabled={disabled}
              id={formValue ?? `${label ?? nolabel}-checkbox`}
            />
          }
        />
      )}
    />
  ) : (
    <FormControlLabelStyled
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      label={label}
      id={`${label ?? nolabel}-labelCheckbox`}
      checked={checked}
      name={name}
      control={
        <Checkbox
          sx={{
            '&:hover': { bgcolor: 'transparent' }
          }}
          disableRipple
          color="default"
          checkedIcon={<BpCheckedIcon />}
          icon={<BpIcon />}
          onClick={onClick}
          onChange={onChange}
          disabled={disabled}
          id={formValue ?? `${label ?? nolabel}-checkbox`}
        />
      }
    />
  )
